import script from "./ColumnLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColumnLayout.vue?vue&type=script&setup=true&lang=ts"

import "./ColumnLayout.vue?vue&type=style&index=0&id=7136338e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7136338e"]])

export default __exports__